import React from 'react';
import logo from '../../assets/images/logo.png';

export default function Home() {
  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        height: '75vh',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <img
        src={logo}
        alt='logo'
      />
    </div>
  );
}
